import { useState } from "react";
import PageHeader from "../../../Layout/PageHeader";
import CreateKitOrdersLayout from "../../../Layout/CreateKitOrdersLayout";
import { kitordersoverviewcompletelist, kitordersoverviewinprogresslist, kitordersoverviewnewlist } from "../../../Data/testData";
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import Table, { Column } from '../../../Components/Tables/Table';
import Tabs from "../../../Shared/Tab/Tab";
import CommonModal from "../../../Components/Modals/CommonModal";
import PrintPackSlipLayout from "../../../Layout/PrintPackSlipLayout";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";


const KitOrdersOverview = () => {

  
  const pageName = "Kit Orders";

  const navigation = useNavigate();
  
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
  useState({
    importModal: false,
    exportModal: false,
  });
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);

  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const handleSelectedRowsChange = (newSelectedRows: Set<number>) => {
    setSelectedRows(newSelectedRows);
  };

  const [showRowClicked, setShowRowClicked] = useState(false);
  const handleRowClick = (data: any) => {
    if (showRowClicked == false) {
      navigation(
        `/inventory/assembly/kit-orders/details/${data.kit_order}`
      );
    }
  };

  const [showPrintPackSlip, setShowPrintPackSlip] = useState(false);
  const handlePrintPackSlipModal = (data: any) => { setShowPrintPackSlip(true) };

  const closePrintPackSlipModal = () =>{
    setShowPrintPackSlip(false)
  }

  const [showconfModal, setShowconfModal] = useState(false);
  const handleconfShow = () => setShowconfModal(true);
  const handleconfClose = () => setShowconfModal(false);
  const handleConfirm = () => {
    console.log("Confirmed!");
    handleconfClose();
  };
  const handleconfCancel = () => {
    console.log("Cancelled!");
    handleconfClose();
  };
  const handelDeleteAction = (data: any) => {
    setShowconfModal(true);
  };

  const columns: Column[] = [
    {
      name: "Kit Order#",
      selector: (row: { kit_order: string }) => (
        <span onClick={() => handleRowClick(row)} className="cursor-pointer text-primary " >
          {row.kit_order}
        </span>
      ),
      enableSorting: true
    },
    {
      name: "Kit Part#",
      selector: (row: { kit_part: string }) => row.kit_part,
    },
    {
      name: "Kit Description",
      selector: (row: { kit_description: string }) =>(
        <span   title={row.kit_description.length > 15 ? row.kit_description : ""}>
        {row.kit_description.length > 15
          ? `${row.kit_description.slice(0, 15)}...`
          : row.kit_description}
      </span>
      ),
    },
    {
      name: "Kit Order Qty",
      selector: (row: { kit_order_qty: string }) => row.kit_order_qty,
    },
    {
      name: "Kit Available",
      selector: (row: { kits_available: string }) => row.kits_available,
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        return row.status === "new" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue">
            New
          </span>
        ) : row.status === "pending_review" ? (
          <span className="badge text asn-overview-status asn-overview-status-border-red">
            Pending Review
          </span>
        ) : row.status === "complete" ? (
          <span className="badge asn-overview-status asn-overview-status-border-green">
            Completed
          </span>
        ) : row.status === "in progress" ? (
          <span className="badge asn-overview-status asn-overview-status-border-yellow">
            In Progress
          </span>
        ) : (
          <></>
        );
      },
    },
    {
      name: (
        <>
          <ArrowLeftRight className="me-2" /> <PlusCircle />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowRowClicked(true)}
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer mt-2 fs-14 fw-medium"
            >
              Edit
            </li>
            <li
              className="cursor-pointer  mt-2 fs-14 fw-medium"
            >
              Pick Ticket Print
            </li>
            <li
              className="cursor-pointer  mt-2 fs-14 fw-medium"
              onClick={() => handlePrintPackSlipModal(row)}
            >
              Print Pack Slip
            </li>
            <li
              className="cursor-pointer  mt-2 fs-14 fw-medium"
              onClick={() => handelDeleteAction(row)}
            >
              Void Order
            </li>
          </ul>
        </>
      ),
    },
  ];

  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const tabs = [
    {
      order: 0,
      label: "New | " + kitordersoverviewnewlist.length,
      content: (
        <div className='mt-2'>
          <Table
            columns={columns}
            data={kitordersoverviewnewlist}
             pagination={{
          recordsPerPage: 15,
          totalRecords: kitordersoverviewnewlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
            CheckboxStatus={true} enableSorting={true}
            onSelectedRowsChange={handleSelectedRowsChange}
          />
        </div>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "In Progress | " + kitordersoverviewinprogresslist.length,
      content: (
        <div className='mt-2'>
          <Table
            columns={columns}
            data={kitordersoverviewinprogresslist}
             pagination={{
          recordsPerPage: 15,
          totalRecords: kitordersoverviewinprogresslist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
            enableSorting={true}
            CheckboxStatus={true}
            onSelectedRowsChange={handleSelectedRowsChange}
          />
        </div>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Completed | " + kitordersoverviewcompletelist.length,
      content: <div className='mt-2'>
        <Table
          columns={columns}
          data={kitordersoverviewcompletelist}
           pagination={{
          recordsPerPage: 15,
          totalRecords: kitordersoverviewcompletelist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          enableSorting={true}
          CheckboxStatus={true}
          onSelectedRowsChange={handleSelectedRowsChange}
        />
      </div>
      ,
      visibility: true,
      status: true,
    },
  ];
  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleconfClose();
  };

  return (
    <>

      <PageHeader
        name=" Create Kit Order"
        isShowUpload={true}
        addUrl="/inventory/assembly/kit-orders"
        isModal={true}
        heading="Kit Orders"
        content={<CreateKitOrdersLayout handleClose={handleShow} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader='create-kit-orders'
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />

      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div >
        <Tabs tabs={tabs} isCheckbox={false} />
      </div>

      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        handleClose={closePrintPackSlipModal}
        show={showPrintPackSlip}
        heading="Print Pack Slip"
        content={<PrintPackSlipLayout handleClose={handleShow} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
      />
      <CommonConfirmationModal
          customClassName="header-border"
            show={showconfModal}
            content="Are you sure you want to void this Kit Order?"
            onModalSubmit={onModalSubmit}
          />
        </>
      )


}

export default KitOrdersOverview
